module.exports = __webpack_public_path__ + "static/media/disasterpets.c0aa72db.jpeg";